// node modules
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
// actions
import { getReservesCheckoutReport } from '../../../redux/checkouts/reports/actions';
// Constants
import { checkoutsReportReservesColumns } from '../../../enums/columns/checkoutsReportReservation';
// Components
import Table from '../../../components/table';
import Spin from '../../../components/loading';
import DatePicker from '../../../components/FormElements/DatePicker/DatePicker';
// Utils
import submitForm from '../../../utils/submitForm';

const initialFormValue = { trackingNumber: '', fromDate: '', toDate: '' };

function ReservesCheckoutReportModal(props) {
  let formRefrence = useRef();
  const dispatch = useDispatch();
  const state = useSelector(state => state.checkoutReportsReducer);

  const [currentPage, setCurrentPage] = useState(1);
  const [sort, setSort] = useState({
    sortType: 'desc',
    sortBy: 'startAt',
    sortQuery: '',
    filterQuery: '',
  });
  const [formData, setFormData] = useState(initialFormValue);
  const [error, setError] = useState('');

  const closeModal = () => {
    props.setShowReserveModal('');
  };

  const buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&sort=${sort.sortQuery || 'startAt-desc'}`;
      if (sort.filterQuery) {
        query += '&' + sort.filterQuery;
      }
      return query;
    }
  };

  const sortTable = columnName => {
    const sortType = sort.sortType === 'asc' ? 'desc' : 'asc';
    setSort({ ...sort, sortType, sortBy: columnName });
  };

  const filterAndSort = () => {
    let searchQuery = buildSearchQuery(currentPage, 10);
    dispatch(getReservesCheckoutReport(props.selectedRecordId, searchQuery));
  };

  const onPageChanged = pageNumber => {
    setCurrentPage(pageNumber);
    const query = buildSearchQuery(pageNumber, 10);
    dispatch(getReservesCheckoutReport(props.selectedRecordId, query));
  };
  const resetForm = () => {
    Array.from(formRefrence.current).forEach(element => {
      if (element.name === 'resetButton') {
        element.value = locales('fields.reset');
      } else {
        element.value = null;
      }
    });
    setFormData(initialFormValue);
    setSort({ ...sort, filterQuery: '' });
  };

  const applyFilters = event => {
    event.preventDefault();
    if (!error) {
      const queryString = submitForm(event);
      setSort({ ...sort, filterQuery: queryString });
    }
  };

  const handleEndDataChange = val => {
    setFormData({ ...formData, toDate: val });
    if (formData.fromDate > val) {
      setError('مقدار وارد شده کوچکتر از تاریخ شروع می باشد');
    } else {
      setError('');
    }
  };

  const handleStartDateChange = val => {
    setFormData({ ...formData, fromDate: val });
    if (val <= formData.toDate) {
      setError('');
    } else if (val > formData.toDate) {
      setError('مقدار وارد شده کوچکتر از تاریخ شروع می باشد');
    }
  };

  useEffect(() => {
    setCurrentPage(currentPage);
    filterAndSort();
  }, [sort]);

  return (
    <Modal isOpen={props.showReserveModal === 'reserve-modal'} size='xl'>
      <ModalHeader>
        <span className='modal-title'>
          {locales('titles.checkoutReportReserves') + props.selectedCafeName}
        </span>
        <span
          title={locales('labels.close.modal')}
          className='modal-close'
          onClick={closeModal}
        >
          close
        </span>
      </ModalHeader>
      <div className='filter-part'>
        <form
          onReset={event => resetForm(event)}
          onSubmit={event => applyFilters(event)}
          id='form'
          ref={formRefrence}
          className='my-4'
        >
          <div className='form-group d-flex col-12'>
            <label className='text-right filter-field-label p-0 col-3'>
              {locales('fields.reserveCode')}
            </label>
            <div className='full-width'>
              <input
                name='trackingNumberPart'
                type='text'
                value={formData.trackingNumber}
                onChange={event =>
                  setFormData({
                    ...formData,
                    trackingNumber: event.target.value,
                  })
                }
                className='form-control'
                placeholder={locales('fields.reserveCode')}
                id='trackingNumberPart'
              />
            </div>
          </div>
          <div className='form-group d-flex col-12'>
            <label className='col-3 text-right filter-field-label p-0'>
              {locales('labels.reserve.date')}
            </label>
            <div className='full-width ml-1'>
              <DatePicker
                marge={true}
                placeholder='تاریخ شروع'
                name='fromDate'
                className='form-control'
                value={formData.fromDate}
                onChange={value => handleStartDateChange(value)}
              />
            </div>
            <div className='full-width'>
              <DatePicker
                marge={true}
                placeholder='تاریخ پایان'
                name='toDate'
                className='form-control'
                value={formData.toDate}
                onChange={v => handleEndDataChange(v)}
              />
            </div>
          </div>
          {error && (
            <div style={{ color: 'red', fontSize: '0.8rem', textAlign: 'end' }}>
              {error}
            </div>
          )}
          <br />
          <div className='mr-auto' style={{ textAlign: 'center' }}>
            <input
              name='resetButton'
              type='reset'
              value={locales('fields.reset')}
              className='btn btn-danger w-5 mx-2'
              maxLength='10'
            />
            <button
              type='submit'
              id='apply-filter-btn-cafe'
              className='btn btn-success w-5 mx-2'
              name='filter'
            >
              {locales('fields.applyFilters')}
            </button>
          </div>
        </form>
      </div>
      <ModalBody>
        <Spin spinning={state.getReservesCheckoutLoading}>
          {state.getReservesCheckoutError ? (
            <div className='alert alert-danger'>
              {locales('messages.server.error')}
            </div>
          ) : (
            <div className='container'>
              {state.getReservesCheckoutFailed && (
                <div className='alert alert-danger'>
                  {state.getReservesCheckoutMessage}
                </div>
              )}
            </div>
          )}
        </Spin>
        <Table
          columns={checkoutsReportReservesColumns}
          dataSource={state.reserves}
          loading={state.getReservesCheckoutLoading}
          action={{}}
          sort={{ type: sort.sortType, action: sortTable }}
          pagination={{
            currentPage: currentPage,
            pageSize: 10,
            totalCount: state.reserve.totalRecords,
            onPageChange: onPageChanged,
          }}
        />
      </ModalBody>
      <ModalFooter>
        <button
          className='btn btn-light mx-1'
          onClick={closeModal}
          disabled={state.loading}
        >
          {locales('labels.close.modal')}
        </button>
      </ModalFooter>
    </Modal>
  );
}

export default ReservesCheckoutReportModal;
